import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarWeek, faList } from "@fortawesome/free-solid-svg-icons";
import "./CourseViewSwitch.css";

/**
 * Button that switches between the course list (1) and the Stundenplan (2).
 * It names the view it leads to, as the customer asked for.
 */
export default class CourseViewSwitch extends React.Component<
  { view: number; onChange: (view: number) => void },
  {}
> {
  render() {
    const toList = this.props.view === 2;
    return (
      <button
        type="button"
        className="course-view-switch"
        onClick={() => this.props.onChange(toList ? 1 : 2)}
      >
        <FontAwesomeIcon icon={toList ? faList : faCalendarWeek} />
        {toList ? "Zur Listenansicht wechseln" : "Zur Kalenderansicht wechseln"}
      </button>
    );
  }
}
